"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickText = void 0;
var ClickText;
(function (ClickText) {
    ClickText["Locations"] = "Orte";
    ClickText["Shipping"] = "zzgl. Versand";
    ClickText["AddToCart"] = "In den Warenkorb";
    ClickText["WhatsApp"] = "WhatsApp";
    ClickText["CopyLink"] = "Link kopieren";
    ClickText["SendEmail"] = "Per E-Mail senden";
    ClickText["Close"] = "X";
    ClickText["AdditionalInformation"] = "Weitere Informationen";
    ClickText["Description"] = "Beschreibung";
    ClickText["LocationDetails"] = "Standortdetails";
    ClickText["Faq"] = "FAQ";
    ClickText["ExperienceReports"] = "Erlebnisberichte";
    ClickText["MapView"] = "Kartenansicht";
    ClickText["ListView"] = "Listenansicht";
    ClickText["MapViewBig"] = "Karte in Gro\u00DFansicht";
    ClickText["LastCheck"] = "Weiter zum letzten Check";
    ClickText["ClusterScrollPDP"] = "Zu den Einzelerlebnissen";
})(ClickText || (exports.ClickText = ClickText = {}));
//# sourceMappingURL=ClickText.js.map